'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Navigation from './Navigation';

export default function ConditionalNavigation() {
  const pathname = usePathname();
  const [is404, setIs404] = useState(false);

  useEffect(() => {
    // Check if we're on a 404 page
    const checkFor404 = () => {
      const has404 = document.querySelector('[data-page="404"]') !== null;
      setIs404(has404);
    };
    
    // Check multiple times to catch DOM updates
    checkFor404();
    const timer1 = setTimeout(checkFor404, 50);
    const timer2 = setTimeout(checkFor404, 150);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [pathname]);

  // Always render Navigation but hide it with CSS on 404 pages
  // This prevents the component from unmounting/remounting
  return (
    <header role="banner" className={is404 ? 'hidden' : ''}>
      <Navigation />
    </header>
  );
}

